const SettingsProperty = () => {
    return (
        <div>
            Property
        </div>
    )
}

export default SettingsProperty;